import { render } from "./Association.vue?vue&type=template&id=b3c737b6&scoped=true&ts=true"
import script from "./Association.vue?vue&type=script&lang=ts"
export * from "./Association.vue?vue&type=script&lang=ts"

import "./Association.vue?vue&type=style&index=0&id=b3c737b6&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c737b6"]])

export default __exports__